import { Tabs } from '@forgeglobal/design-framework';
import TabContent from '@tcs/common/components/atoms/TabContent';
import AccountsHeader from '@tcs/client-portal-common/components/organisms/Header/IndividualAccountsHeader';
import AccountsOverview from './AccountsOverview';
import AccountsDetails from '@tcs/client-portal-individual/pages/Accounts/AccountsDetails';
import useAccounts from '@tcs/client-portal-common/hooks/useAccounts';
import AccountsActivity from './AccountsActivity';
import { Route } from 'react-router';
import AssetValuation from './AssetValuation';

const Accounts = () => {
  const { data: allAccounts, loading } = useAccounts();

  if (!allAccounts) {
    return;
  }

  return (
    <AccountsHeader
      accounts={allAccounts}
      loading={loading}
      tabs={() => (
        <Tabs>
          <Route
            path="*"
            element={
              <TabContent label="Overview" data-test-id="accounts-overview-tab">
                <AccountsOverview accounts={allAccounts} loading={loading} />
              </TabContent>
            }
          />
          <Route
            path="/activity"
            element={
              <TabContent label="Activity" data-test-id="accounts-activity-tab">
                <AccountsActivity />
              </TabContent>
            }
          />
          <Route
            path="/details"
            element={
              <TabContent label="Details" data-test-id="accounts-details-tab">
                <AccountsDetails accounts={allAccounts} />
              </TabContent>
            }
          />
          <Route
            path="/asset_valuation"
            element={
              <TabContent
                label="Asset Valuation"
                data-test-id="accounts-asset-valuation">
                <AssetValuation accounts={allAccounts} />
              </TabContent>
            }
          />
        </Tabs>
      )}
    />
  );
};

export default Accounts;
